import React, { FC } from 'react'
import { withProcedureWraper } from '..'

export const ProcedureTrainingPage: FC = withProcedureWraper(() => {

  return (
    <div className="ProcedureTrainingPage"></div>
  )
})